export const checkIfEmptyObject = (object: Object): boolean => {
  return Object.values(object).every((key) => key === null || key === '' || key === undefined);
};
